module.exports = __webpack_public_path__ + "static/transaction-categorizer-914b1594b47a1a6d8ad4a5da7c6f7a66.svg";